module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/EMBLEM.6eaaf21f.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/EMBLEM.png
// module id = 1281
// module chunks = 16